/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
} from './Account';

/**
 * 
 * @export
 * @interface UserAccountResponse
 */
export interface UserAccountResponse {
    /**
     * 
     * @type {Account}
     * @memberof UserAccountResponse
     */
    data?: Account;
}

/**
 * Check if a given object implements the UserAccountResponse interface.
 */
export function instanceOfUserAccountResponse(value: object): value is UserAccountResponse {
    let isInstance = true;

    return isInstance;
}

export function UserAccountResponseFromJSON(json: any): UserAccountResponse {
    return UserAccountResponseFromJSONTyped(json, false);
}

export function UserAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : AccountFromJSON(json['data']),
    };
}

export function UserAccountResponseToJSON(value?: UserAccountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AccountToJSON(value.data),
    };
}

